import { Form, Input, Button, Toast } from 'antd-mobile';
import { useMutation } from '@apollo/client';
import { t } from '../../i18n';
import { getCurrentLocation } from 'utils/locationUtils';
import { REPORT_LOCATION_IP, ReportLocationIpResult } from '../../graphql/mutations/reportLocationIp';

export default function ReportIpPage() {
  const [reportLocationIp, { loading }] = useMutation<ReportLocationIpResult>(REPORT_LOCATION_IP);

  const onFinish = async (values: { locationName: string }) => {
    let latitude: number | null = null;
    let longitude: number | null = null;

    const locationResult = await getCurrentLocation({ useCache: false });
    if (locationResult.location) {
      latitude = locationResult.location.latitude;
      longitude = locationResult.location.longitude;
    } else {
      Toast.show({ content: t('pda.reportIp.report.location.unavailable') });
    }

    await reportLocationIp({
      variables: {
        locationName: values.locationName,
        latitude,
        longitude,
      },
    });

    Toast.show({ icon: 'success', content: t('pda.reportIp.report.success') });
  };

  return (
    <div className="flex flex-col min-h-screen px-6 justify-center">
      <div className="flex flex-col items-center gap-3 mb-10">
        <h1 className="text-xl font-semibold text-gray-900">
          {t('pda.reportIp.report.title')}
        </h1>
        <p className="text-sm text-gray-500 text-center leading-relaxed max-w-[320px]">
          {t('pda.reportIp.report.description')}
        </p>
      </div>
      <Form
        requiredMarkStyle="none"
        onFinish={onFinish}
        style={{
          "--border-bottom": "none",
          "--border-top": "none",
          "--border-inner": "none",
        }}
        footer={
          <Button block type="submit" color="primary" size="large" loading={loading}>
            {t('pda.reportIp.report.submit.label')}
          </Button>
        }
      >
        <Form.Item
          name="locationName"
          rules={[{ required: true, message: t('pda.reportIp.report.locationName.required') }]}
        >
          <Input
            placeholder={t('pda.reportIp.report.locationName.placeholder')}
            maxLength={255}
            className="border border-gray-300 rounded-lg px-3 py-2"
          />
        </Form.Item>
      </Form>
    </div>
  );
}
